import React from 'react';

const FormToggle = ({ name, type1, type2, onValueChange, value, element = undefined, boolean = false }) => {
    return (
        <div className="flex-h mt-16" style={{ alignItems: 'center' }}>
            <h4>{name} :</h4>
            <div className="flex-v ml-40">
                <div className="tabs is-toggle is-toggle-rounded">
                    <ul>
                        <li onClick={() => onValueChange(boolean ? true : type1.toUpperCase().substring(0, 1), element)} className={`${(boolean ? value : value === type1.toUpperCase().substring(0, 1)) && 'is-active'}`}>
                            <a>
                                <h3>{type1}</h3>
                            </a>
                        </li>
                        <li onClick={() => onValueChange(boolean ? false : type2.toUpperCase().substring(0, 1), element)} className={`${(boolean ? !value : value === type2.toUpperCase().substring(0, 1)) && 'is-active'}`}>
                            <a>
                                <h3>{type2}</h3>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default FormToggle;